import * as React from 'react'
import {ThemedIcon} from '../components/themed-icon/ThemedIcon'
import {ReactComponent as Svg} from './images/person-role.svg'

export function PersonRoleIcon() {
  return (
    <ThemedIcon size={22} active={true}>
      <Svg />
    </ThemedIcon>
  )
}
